export default import.meta.ROLLDOWN_FILE_URL_Vmbmm1vx75jqgYklwI_8sA